var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Error',{attrs:{"title":"利用権限がありません","lead":"このページにアクセスする権限がありません"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v("\n    確認後、再度アクセスしてください。\n  ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }